// @flow

import {useContext} from 'react';
import {BrandInfoContext} from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';

const useBRRedesign = (): boolean => {
  const {abbrBrand} = useContext(BrandInfoContext);
  const isFeatureFlagActive = useEnabledFeature('cat-br-redesign');
  return (abbrBrand === 'br' || abbrBrand === 'brfs') && isFeatureFlagActive;
};

export default useBRRedesign;
